// Community Point Management APIs

/**
 * @function ApiClient#GetPoint
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} params 參數。
 * @param {any} params.building
 * @param {any} params.doorPlate
 * @param {any} params.floor
 * @param {any} options = {}
 */
export async function GetPoint(cid, { building, doorPlate, floor }, options = {}) {
  return await this._get(`/community/${cid}/point?b=${building}&d=${doorPlate}&f=${floor}`, options);
}

/**
 * @function ApiClient#UpdatePoint
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} pch
 * @param {any} options = {}
 */
export async function UpdatePoint(cid, pch, options = {}) {
  return await this._post(`/community/${cid}/point`, pch, options);
}

/**
 * @function ApiClient#GetPointHistory
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} params 參數。
 * @param {any} params.sortBy
 * @param {any} params.sortDesc
 * @param {any} params.page
 * @param {any} params.itemsPerPage
 * @param {any} params.startDate
 * @param {any} params.endDate
 * @param {any} params.building
 * @param {any} params.doorPlate
 * @param {any} params.floor
 * @param {any} params.pointType
 * @param {any} params.changeMethod
 * @param {any} options = {}
 */
export async function GetPointHistory(
  cid,
  { sortBy, sortDesc, page, itemsPerPage, startDate, endDate, building, doorPlate, floor, pointType, changeMethod },
  options = {},
) {
  if (!startDate) startDate = "";
  if (!endDate) endDate = "";
  if (!building) building = "";
  if (!doorPlate) doorPlate = "";
  if (!floor) floor = "";
  if (!pointType) pointType = "";
  if (!changeMethod) changeMethod = "";

  return await this._get(
    `/community/${cid}/point_history?p=${page}&sb=${sortBy}&sd=${sortDesc}&pp=${itemsPerPage}&st=${startDate}&et=${endDate}&b=${building}&d=${doorPlate}&f=${floor}&pt=${pointType}&cm=${changeMethod}`,
    options,
  );
}

/**
 * @function ApiClient#GetPointList
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function GetPointList(cid, options = {}) {
  return await this._get(`/community/${cid}/point_list`, options);
}

/**
 * @function ApiClient#ExportPointList
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function ExportPointList(cid, options = {}) {
  return await this._get(`/community/${cid}/point_export`, options);
}

/**
 * @function ApiClient#ImportPointList
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} xlsxFile
 * @param {any} options = {}
 */
export async function ImportPointList(cid, xlsxFile, options = {}) {
  const formData = new FormData();
  formData.set("Xlsx", xlsxFile);
  return await this._post(`/community/${cid}/point_import`, formData, options);
}

// Point Item Type Management APIs

/**
 * @function ApiClient#GetPointItemTypeList
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function GetPointItemTypeList(cid, options = {}) {
  return await this._get(`/community/${cid}/point_item_type_list`, options);
}

/**
 * @function ApiClient#AddPointItemType
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} newItem
 * @param {any} options = {}
 */
export async function AddPointItemType(cid, newItem, options = {}) {
  return await this._post(`/community/${cid}/point_item_type`, newItem, options);
}

/**
 * @function ApiClient#UpdatePointItemType
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} itemList
 * @param {any} options = {}
 */
export async function UpdatePointItemType(cid, itemList, options = {}) {
  return await this._put(`/community/${cid}/point_item_type`, itemList, options);
}

/**
 * @function ApiClient#DeletePointItemType
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} pitID
 * @param {any} options = {}
 */
export async function DeletePointItemType(cid, pitID, options = {}) {
  return await this._delete(`/community/${cid}/point_item_type/${pitID}`, options);
}

// Point Item Management APIs

/**
 * @function ApiClient#GetPointItemListAll
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function GetPointItemListAll(cid, options = {}) {
  return await this._get(`/community/${cid}/point_item_list?itid=all`, options);
}

/**
 * @function ApiClient#GetPointItemList
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} itemTypeID
 * @param {any} options = {}
 */
export async function GetPointItemList(cid, itemTypeID, options = {}) {
  return await this._get(`/community/${cid}/point_item_list?itid=${itemTypeID}`, options);
}

/**
 * @function ApiClient#AddPointItem
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} newItem
 * @param {any} options = {}
 */
export async function AddPointItem(cid, newItem, options = {}) {
  return await this._post(`/community/${cid}/point_item`, newItem, options);
}

/**
 * @function ApiClient#UpdatePointItem
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} itemList
 * @param {any} options = {}
 */
export async function UpdatePointItem(cid, itemList, options = {}) {
  return await this._put(`/community/${cid}/point_item`, itemList, options);
}

/**
 * @function ApiClient#DeletePointItem
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} itID
 * @param {any} options = {}
 */
export async function DeletePointItem(cid, itID, options = {}) {
  return await this._delete(`/community/${cid}/point_item/${itID}`, options);
}
